import styled from "styled-components"

const ProductHero = () => {
    return (
        <div style={{marginTop: '6rem'}}>
            <Wrapper>
                <h1>Savings & Investment Products</h1>
                <p>Invest–Trust Limited is a timely provider of investment products and services that incorporates global best practices and modern technology in delivering absolute quality.</p>
            </Wrapper>
                
        </div>
    )
}

export default ProductHero

export const Wrapper = styled.div`
  transform: translateY(-2rem);
  background-image: url("https://res.cloudinary.com/dvwbbiu0g/image/upload/v1651531019/invest-trust/section_b_fftu3z.svg");
  color: ${({ theme }) => theme.colors.text};
  margin-bottom: 5rem;
  h1 {
    padding-top: 2.5rem;
    text-align: center;
    font-size: 3rem;
    font-family: "Futura";
    Line-height: 56px;
    font-weight: 200;
  }
  p {
    text-align: center;
    font-size: 1.25rem;
    width: 37.5rem;
    margin: auto;
    padding-bottom: 20rem;
  }
  @media screen and (max-width: 991px) {
    h1 {
      margin-left: 5rem;
      margin-right: 5rem;
      padding-top: 2.5rem;
      text-align: center;
      font-size: 2rem;
    }
    p {
      text-align: center;
      font-size: 1.25rem;
      width: 70%;
      margin: auto;
      padding-bottom: 3.5rem;
    }
  }
  @media screen and (max-width: 579px) {
    padding-top: 0.1rem;
    padding-bottom: 2rem;

    h1 {
      width: 80%;
      margin-left: 2rem;
      margin-right: 2rem;
      padding-top: 0.5rem;
      text-align: center;
      font-size: 3rem;
      Line-height: 56px;
    }
    div {
      margin: auto;
    }
    p {
      width: 80%;
      text-align: center;
      font-size: 20px;
      margin: auto;
    }
  }
`;


